module.exports = __webpack_public_path__ + "img/horizontal_6_2_8019.dfcc655f.png";